module.exports = __webpack_public_path__ + "static/media/chess-rook.6b0a1d0e.svg";